var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftLong = function SvgArrowLeftLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8 5H3.4l3.3-3.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-5 5c-.2.1-.3.4-.3.7s.1.5.3.7l5 5c.2.2.4.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L3.4 7h24.4c.6 0 1-.4 1-1s-.4-1-1-1"
  })));
};
export default SvgArrowLeftLong;